import dayjs from "dayjs";
import {
  DayPicker,
  getDefaultClassNames,
  type DayPickerProps,
} from "react-day-picker";
import { ar } from "react-day-picker/locale";
import "react-day-picker/style.css";

import { useLocaleInfo } from "@/app/lib/hooks/useLocaleInfo";

const formatWeekdayName = (date: Date) => {
  return dayjs(date).format("ddd");
};

const formatMonthCaption = (date: Date) => {
  return dayjs(date).format("MMMM YYYY");
};

export function CalendarBase({
  startMonth,
  endMonth,
  classNames,
  ...props
}: DayPickerProps) {
  const { locale, dir } = useLocaleInfo();

  const defaultClassNames = getDefaultClassNames();

  const pickerProps: DayPickerProps = {
    locale: locale === "ar" ? ar : undefined,
    dir,
    formatters: {
      formatWeekdayName,
      formatMonthCaption,
    },
    startMonth: startMonth || new Date(1940, 1),
    endMonth: endMonth || new Date(2050, 1),
    classNames: {
      day: "text-text-primary",
      chevron: "fill-text-interactive",
      month_caption: `${defaultClassNames.month_caption} text-text-interactive text-lg font-bold text-center`,
      selected: "selected-day",
      ...classNames,
    },
    navLayout: "around",
    ...props,
  };

  return (
    <div className="flex items-center justify-center" data-sentry-block>
      <DayPicker {...pickerProps} />
    </div>
  );
}
